import { tv } from 'tailwind-variants';

export const styles = tv({
  base: `
    flex
    items-center
  `,
  slots: {
    backLink: `
      flex
      items-center
      gap-2
    `,
    backLinkChevron: `
      mt-0.5
      h-2
      fill-green-700
      font-normal
    `,
    text: `
      max-w-[180px]
      truncate
    `,
    list: `
      flex
      items-center
    `,
    listItem: `
      flex
      items-center
    `,
    listItemChevron: `
      mx-4
      h-2
      fill-gray-600
      font-normal
    `,
  },
});
